<template>
	<!-- eslint-disable vue/no-use-v-if-with-v-for,vue/no-confusing-v-for-v-if -->
	<b-row>
		<b-col>
			<b-row>
				<b-col>
					<div v-if="!$store.state.isMobile" :class="expand ? 'collapsible expanded collapsible__bicycle' : 'collapsible collapsed collapsible__bicycle'" style="position: relative">

						<div class="collapsible-heading">
							<div class="d-flex">
								<div class="collapsible-heading__image" @click="onToggleExpand">
									<b-img v-show="expand" :src="LaneClosureRequest.getBicycleLaneImageLight(bicycleLaneId)" fluid style="height:30px"></b-img>
									<b-img v-show="!expand" :src="LaneClosureRequest.getBicycleLaneImage(bicycleLaneId)" fluid style="height:30px"></b-img>
								</div>
							<div class="flex-grow-1 collapsible-heading__title" @click="onToggleExpand">{{LaneClosureRequest.getBicycleLaneText(bicycleLaneId)}} </div>
							<div class="collapsible-heading__status" @click="onToggleExpand"><div class="flex-table"><div class="flex-table-cell" v-html="getInEffectTitle()"></div></div></div>
							<div class="collapsible-heading__toggle">
								<div class="flex-table">
									<b-button href="#" variant="collapsible"
										:class="expand ? 'flex-table-cell' : 'flex-table-cell collapsed'"
										:aria-expanded="expand ? 'true' : 'false'"
										aria-controls="collapseBicycleListing"
										@click="onToggleExpand"
										>
									<span class="when-opened">
									<font-awesome-icon icon="chevron-down" />
									</span>
									<span class="when-closed">
									<font-awesome-icon icon="chevron-right" />
									</span>
									</b-button>
								</div>
							</div>
							<div v-if="!$store.getters.isReadOnly()" class="collapsible-heading__set-buttons">
							<b-dropdown text="Set All">
								<b-dropdown-item @click="onAllClosed()">Closed</b-dropdown-item>
								<b-dropdown-item @click="onAllOpen()">Open</b-dropdown-item>
							</b-dropdown>
							</div>

						</div>
						</div>
						<b-collapse id="collapseBicycleListing" :visible="expand"  class="collapsible-entries">
							<div :class="flexClasses(b2index)" v-if="isEntry(b2index)" v-for=" (b, b2index) in value" :key="'blb2index'+b2index+'-'+renderCounter">
								<div class="collapsible-entry__switch-wrapper">
									<div class="closed-open-switch-field">
											<input :id="switchId('rbicycle',b2index,bicycleLaneId)" :disabled=$store.getters.isReadOnly()  class="closed-open-switch" :checked="getChecked(b2index)" type="checkbox" @change="toggleSwitch(b2index)" >
											<label :for="switchId('rbicycle',b2index,bicycleLaneId)"></label>
									</div>
								</div>
								<div class="flex-grow-1 pl-3">
									<div class="d-flex collapsible-entry__title-wrapper">
										<div class="flex-grow-1 collapsible-entry__title"><a href="#" @click="showOnMap(b.blockId)">{{LaneClosureRequest.getDirectionAbbreviationText(b.directionId)}} {{b.streetName.value}} between <span>{{b.fromStreet.value}}</span> and <span>{{b.toStreet.value}}</span></a></div>
										<div class="collapsible-entry__map-button"><b-button class="pl-2 pr-2 pt-2 pb-2" variant="text" type="button" @click="showOnMap(b.blockId)"><img class="view-map-icon" src="@/assets/map-icon-blue.svg" style="width:20px"/></b-button></div>
									</div>
								</div>
							</div>
						</b-collapse>
					</div>



					<div v-if="$store.state.isMobile"  :class="expand ? 'collapsible expanded collapsible__bicycle' : 'collapsible collapsed collapsible__sidewalk'" style="position: relative">
						<div class="collapsible-heading">
							<div class="d-flex">
								<div class="collapsible-heading__image cycle-mobile" @click="onToggleExpand">
									<b-img :src="LaneClosureRequest.getBicycleLaneImage(bicycleLaneId)" fluid style="height:30px"></b-img>
								</div>
							<div class="flex-grow-1 collapsible-heading__title" @click="onToggleExpand">
								{{LaneClosureRequest.getBicycleLaneText(bicycleLaneId)}}
							</div>
							<div @click="onToggleExpand" class="collapsible-heading__effect">
								<div class="flex-table"><div class="flex-table-cell" v-html="getInEffectTitle()"></div></div>
							</div>
							<div class="collapsible-heading__toggle">
								<div class="flex-table">
									<b-button href="#" variant="collapsible"
										:class="expand ? 'flex-table-cell' : 'flex-table-cell collapsed'"
										:aria-expanded="expand ? 'true' : 'false'"
										aria-controls="collapseBicycleListing"
										@click="onToggleExpand"
										>
									<span>
									<font-awesome-icon icon="chevron-right" />
									</span>
									</b-button>
								</div>
							</div>
						</div>
						</div>
					</div>
					<div v-if="$store.state.isMobile && expand">
						<transition  name="slide-fade" tag="div">
						<div class="d-block section-slide-panel has-menu" v-if="showPanel">
								<div class="top-controls">
									<span @click="onSwipeRight">
										<b-img src="/img/nav/icon-back.svg" alt="menu" /> Back
									</span>
								</div>
								<div class="panels-body panels-body-padded">
									<div class="panels-nav-title" v-html="getNavTitle"></div>
									<div class="panels-primary-title" v-html="getModalTitle"></div>
									<div class="panels-body-content">
										<div :class="flexClasses(b2index)" v-if="isEntry(b2index)" v-for=" (b, b2index) in value" :key="'blb2index'+b2index+'-'+renderCounter">
											<div class="collapsible-entry__switch-wrapper">
												<div class="closed-open-switch-field">
														<input :id="switchId('rbicycle',b2index,bicycleLaneId)" :disabled=$store.getters.isReadOnly() class="closed-open-switch" :checked="getChecked(b2index)" type="checkbox" @change="toggleSwitch(b2index)" >
														<label :for="switchId('rbicycle',b2index,bicycleLaneId)"></label>
												</div>
											</div>
											<div class="flex-grow-1 pl-3">
												<div class="d-flex collapsible-entry__title-wrapper">
													<div class="flex-grow-1 collapsible-entry__title"><a href="#" @click="showOnMap(b.blockId)">{{LaneClosureRequest.getDirectionAbbreviationText(b.directionId)}} {{b.streetName.value}} between <span>{{b.fromStreet.value}}</span> and <span>{{b.toStreet.value}}</span></a></div>
													<div class="collapsible-entry__map-button"><b-button class="pl-2 pr-2 pt-2 pb-2" variant="text" type="button" @click="showOnMap(b.blockId)"><img class="view-map-icon" src="@/assets/map-icon-blue.svg" style="width:20px"/></b-button></div>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div class="panels-apply">
									<div class="d-flex">
										<div class="panels-apply__close"><b-button @click="onAllClosed()" variant="light" class="close-button" type="button"><img src="/img/assets/set-all-close.svg" alt="" />Closed</b-button></div>
										<div class="panels-apply__open"><b-button @click="onAllOpen()" variant="light" class="open-button" type="button"><img src="/img/assets/set-all-open.svg" alt="" />Open</b-button></div>
										<div class="panels-apply__save"><b-button @click="onApply" variant="secondary" class="save-button" type="button"><img src="/img/assets/icon-checkmark-blue.svg"/>Apply</b-button></div>
									</div>
								</div>
							</div>
						</transition>
					</div>
				</b-col>
			</b-row>
		</b-col>
	</b-row>
</template>

<script>
import LaneClosureRequest from './../models/LaneClosureRequest.js'
import Vue from 'vue'

export default {
	name: 'ReportLaneClosureRequestBlockBicycleListing',
	props: ['value', 'preset', 'bicycleLaneId', 'expand'],
	data() {
		return {
			isEditing: false,
			editingIndex: null,
			LaneClosureRequest: LaneClosureRequest,
			backupBlock: null,
			errorMsg: null,
			lastIndex: null,
			renderCounter:0,
			backup: {},
			showPanel: false
		}
	},
	mounted() {
		this.showPanel = this.expand;
		Vue.prototype.$bus.$on('swipe:right:panel', this.onSwipeRight);
     },
     destroyed() {
		Vue.prototype.$bus.$off('swipe:right:panel', this.onSwipeRight);
     },
   watch: {

   },
	computed: {
		getNavTitle() {
			return "Report Bicycle Lanes Opened/Closed";
		},
		getModalTitle() {
			return LaneClosureRequest.getBicycleLaneText(this.bicycleLaneId);
		},
		entries: function() {
			let that = this;
			return this.value.filter(function(entry) {
				let x = 0;
				if (entry.bicycle) {
					for (x = 0; x < entry.bicycle.length; x++) {
						if (entry.bicycle[x].bicycleLaneId.value == that.bicycleLaneId) {
							return true;
						}
					}
				}
				return false;
			})
		},
		nonEntries: function() {
			let that = this;
			return this.value.filter(function(entry) {
				let x = 0;
				if (entry.bicycle) {
					for (x = 0; x < entry.bicycle.length; x++) {
						if (entry.bicycle[x].bicycleLaneId.value == that.bicycleLaneId) {
							return false;
						}
					}
				}
				return true;
			})
		},
	},
	methods: {
		getInEffectTitle() {
			var texts = [];
			texts["1"] = 0;
			texts["0"] = 0;
			texts["null"] = 0;

			if (this.value) {
				for (var index = 0; index < this.value.length; index++) {
					for (var x = 0; x < this.value[index].bicycle.length; x++) {
						if (this.value[index].bicycle[x].bicycleLaneId.value == this.bicycleLaneId) {
							texts["" + this.value[index].bicycle[x].inEffect.value]++;
						}
					}
				}
			}
			var html = "";
			// we're going to make the null values as being open by default when reporting.
			if (texts["null"] > 0) {
				// not reported
				texts["0"] += texts["null"];
			}


			if (texts["1"] > 0) {
				// closed
				html += "<div class='status-circle lc-closed'>" + texts["1"] + "</div>";
			}
			if (texts["0"] > 0) {
				// open
				html += "<div class='status-circle lc-open'>" + texts["0"] + "</div>";
			}
			return html;
		},
		getChecked: function(bindex) {
			if (this.value) {
				if (this.value[bindex]) {
					for (var x = 0; x < this.value[bindex].bicycle.length; x++) {
						if (this.value[bindex].bicycle[x].bicycleLaneId.value == this.bicycleLaneId) {
							if (this.value[bindex].bicycle[x].inEffect.value == 1) {
								return true;
							}
						}
					}
				}
			}
			return false;
		},
		toggleSwitch(bindex) {
			if (this.value) {
				if (this.value[bindex]) {
					for (var x = 0; x < this.value[bindex].bicycle.length; x++) {
						if (this.value[bindex].bicycle[x].bicycleLaneId.value == this.bicycleLaneId) {
							this.$bus.$emit('report-closure-block-details:toggle-bicycle-in-effect', { block: bindex, bicycle:x });
						}
					}
				}
			}
		},
		getInEffectText(index) {
			if (this.value) {
				if (this.value[index]) {
					for (var x = 0; x < this.value[index].bicycle.length; x++) {
						if (this.value[index].bicycle[x].bicycleLaneId.value == this.bicycleLaneId) {
							return LaneClosureRequest.getBicycleInEffectText(this.value[index].bicycle[x].inEffect.value);
						}
					}
				}
			}
			return null;
		},
		classes: function(index) {
			if (this.isEntry(index)) {
				return "is-entry";
			} else {
				return "is-not-entry";
			}
		},
		flexClasses: function(index) {
			if (this.isEntry(index)) {
				return "d-flex collapsible-entry";
			} else {
				return "d-flex ";
			}
		},
		isEntry: function(index) {
			if (this.value) {
				if (this.value[index]) {
					for (var x = 0; x < this.value[index].bicycle.length; x++) {
						if (this.value[index].bicycle[x].bicycleLaneId.value == this.bicycleLaneId) {
							return true;
						}
					}
				}
			}
			return false;
		},
		switchId(prefix,block,id) {
			return prefix+"-"+block+"-"+id;
		},
		shouldShowChanges(idx) {
			if (this.isEditing) {
				return true;
			}
			return false;
		},
		editBlock: function(id) {
			Vue.prototype.$bus.$emit("block:edit-bicycle",id);
		},
		showOnMap: function(id) {
			Vue.prototype.$bus.$emit("block:show-on-map",{id, type: "bicycle", laneId: this.bicycleLaneId});
		},
		addBlock: function(bicycleLaneId, blockId) {
			this.renderCounter++;
			Vue.prototype.$bus.$emit("block:list-add-bicycle",{bicycleLaneId:bicycleLaneId, blockId:blockId});
		},
		toggleRemoveBlock: function(index) {
			this.renderCounter++;
			if (this.isEntry(index)) {
				Vue.prototype.$bus.$emit("block:list-remove-bicycle",{bicycleLaneId:this.bicycleLaneId, blockId:this.value[index].blockId});
			} else {
				Vue.prototype.$bus.$emit("block:list-add-bicycle",{bicycleLaneId:this.bicycleLaneId, blockId:this.value[index].blockId});
			}

		},
		onAllClosed() {
			if (this.value) {
			for (var bindex = 0; bindex < this.value.length; bindex++) {
					for (var x = 0; x < this.value[bindex].bicycle.length; x++) {
						if (this.value[bindex].bicycle[x].bicycleLaneId.value == this.bicycleLaneId) {
							this.$bus.$emit('report-closure-block-details:toggle-bicycle-in-effect', { block: bindex, bicycle:x, value:1 });
						}
					}
				}
			}
		},
		onAllOpen() {
			if (this.value) {
			for (var bindex = 0; bindex < this.value.length; bindex++) {
					for (var x = 0; x < this.value[bindex].bicycle.length; x++) {
						if (this.value[bindex].bicycle[x].bicycleLaneId.value == this.bicycleLaneId) {
							this.$bus.$emit('report-closure-block-details:toggle-bicycle-in-effect', { block: bindex, bicycle:x, value:0 });
						}
					}
				}
			}
		},
		onReview: function() {
			Vue.prototype.$bus.$emit("block:list-expand-bicycle",{bicycleLaneId:this.bicycleLaneId,expand:true});
		},

		onApply: function() {
			this.showPanel = false;
			setTimeout(() => {
				let that = this;
				Vue.prototype.$bus.$emit("block:list-expand-bicycle",{bicycleLaneId:that.bicycleLaneId,expand:!that.expand});
			}, 250);
		},


		onSwipeRight() {
			if (this.showPanel) {
				this.showPanel = false;
				setTimeout(() => {
					let that = this;
					Vue.prototype.$bus.$emit("block:list-expand-bicycle",{bicycleLaneId:that.bicycleLaneId,expand:!that.expand});
				}, 250);
			}
		},

		onToggleExpand: function() {
			this.renderCounter++;
			Vue.prototype.$bus.$emit("block:list-expand-bicycle",{bicycleLaneId:this.bicycleLaneId,expand:!this.expand});
		},

	}
}
</script>
